<template>
  <b-modal ref="modalControleLienFicheTechnique" scrollable size="lg" title="Vérifier les liens de fiches techniques"
      ok-title="Fermer"
      :ok-only=true
      no-close-on-backdrop
      @show="initialiserModale()"
      @ok="fermer()">
      <template slot="default">
        <div style="display: inline">
          <div v-if="FTEnCours && resultatImportFT" class="container-fluid card card-body">
            <div class="row">
              <div class="col-12 form-group">
                <i :class="[{'fas fa-spinner fa-spin mr-2':resultatImportFT && resultatImportFT.fichierEnCours },
                            {'fas fa-exclamation-circle text-error mr-2':resultatImportFT && !resultatImportFT.fichierEnCours && !resultatImportFT.fichierTraiteSucess},
                            {'fas fa-check-circle text-primary mr-2':resultatImportFT && !resultatImportFT.fichierEnCours && resultatImportFT.fichierTraiteSucess},
                           ]"></i>{{ resultatImportFT.etatImport }} 
              </div>
            </div>
            <div class="row">
              <div class="col-12 form-group">
                <em>
                  <p>
                    Merci de vérifier vos propositions avant de les envoyer
                  </p>
                </em>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
</template>

<script>

import { copierFichesTechniques } from '@/api/gpao/propositions'
import { connecteData } from "@/mixins/connecteData"


export default {
  name: "ModalControleLienFicheTechnique",
  props: {
    datePropoId: {type: Number},
    familleId: {type: Number},
    nomFamille: {type: String},
  },
  mixins: [ connecteData ],
  data() {
    return {
      resultatImportFT: null,
      FTEnCours: false,
      nombreLien: 0
    }
  },
  watch: {
    
  },
  computed: {
    
  },
  methods: {

    initialiserModale() {
      //on affiche la modale de suivi du chargement avec l'etat initial
      //this.resultatImportFichier = {fichierEnCours: true, fichierTraiteSucess: false, etatImport: ""}
      this.copierFT()
    },
    
    copierFT() {
        this.FTEnCours = true
        let debutMessage = "Téléchargement des " + this.nombreLien + " fiches techniques de la famille " + this.nomFamille
        this.resultatImportFT = {fichierEnCours: true, fichierTraiteSucess: false, etatImport: debutMessage + " en cours ..."}
        copierFichesTechniques(this.fournisseurCourantId, this.datePropoId, this.familleId, false, 300000) //On met le timeout à 5 minutes, et on télécharge uniquement les liens en erreurs
                .then((r) => {
                    this.resultatImportFT.fichierEnCours=false; 
                    this.resultatImportFT.fichierTraiteSucess=true; 
                    this.resultatImportFT.etatImport=debutMessage + " terminé."
                    return r
                  })
                .catch((ex) => {
                    //Le back Espace Fournisseur à capter l'erreur et mis à jour les propos, donc ici on affiche juste l'erreur dans la modale si elle est toujours visible
                    this.resultatImportFT.fichierEnCours=false; 
                    this.resultatImportFT.fichierTraiteSucess=false
                    this.resultatImportFT.etatImport=debutMessage + " en erreur."
                    return ex
                  })
    },

    fermer() {
      if (!this.resultatImportFT.fichierEnCours) {
        this.$emit("rechargerPropo")
        this.hide()  
      }
    },
    show(nbLien) {
      this.nombreLien = nbLien
      this.$refs.modalControleLienFicheTechnique.show()
    },
    hide() {
      if (!this.resultatImportFT.fichierEnCours) {
        this.$refs.modalControleLienFicheTechnique.hide()
      }
    }
  }
}
</script>